<template>
    <div id="app">
        <router-view></router-view>
        <!-- <hxl-icon name="caomei"></hxl-icon>
        <hxl-icon name="ningmeng"></hxl-icon>
        <hxl-icon name="hongluobu"></hxl-icon> -->
        <!-- <i class="hxl-icon-caomei"></i>
        <i class="hxl-icon-shanzhu"></i>
        <i class="hxl-icon-taozi"></i> -->

        <!-- <router-link to="/" tag="div">跳转到a</router-link>
        <router-link to="/b" target="_blank">跳转到b</router-link>
        <router-link to="/c">跳转到c</router-link> -->

        <!-- 以下是没有历史记录的 -->
        <!-- <router-link to="/" replace>跳转到a</router-link>
        <router-link to="/b" replace>跳转到b</router-link>
        <router-link to="/c" replace>跳转到c</router-link> -->
    </div>
</template>

<script>
// import router from "vue-router";
// import vuex from "vuex";
export default {
    name: "App",
    mounted() {
        // '抓彩票开奖信息 -- 前置操作'
        // this.$http.post('/jsoup/info')
    },
};
</script>

<style lang="scss">
@import "@/components/hxl-icon/iconfont.css";
@import "@/assets/commonStyle.scss";
</style>
